<template>
  <div class="wrapper product-manage-commission main-container">
    <loading :isShow="pageLoading" />
    <div class="header" :style="$units.pointAction('pro_7_1')?'':'margin-bottom:36px;'">
      <span>产品名称：{{ pageQuery.name }}</span>
      <span>产品编码： {{ pageQuery.code || '-' }}</span>
      <span>保司：{{ productBase.companyName || '-' }}</span>
      <span>供应商：{{ productBase.supplierName || '-' }}</span>
      <Button @click="back('/productResource/feeUpstreamCofnig')" v-if="pageType != 'modal'" type="primary" ghost>返回</Button>
    </div>
    <p v-if="activityInfo.title" class="activity-info">
      <span>活动名称：{{ activityInfo.title }}</span>
      <span>活动时间：{{ activityInfo.startTime }} - {{ activityInfo.endTime }}</span>
    </p>
    <p v-if="$units.pointAction('pro_7_1')" class="tip">
      *尽量不要删除历史版本，也不要修改当前或历史版本产品的方案或费用，否则之后入库的历史保单费用可能缺失或者和修改前同一产品同一方案的历史保单费用数据不一致
    </p>
    <p v-if="$units.pointAction('pro_7_1')" class="tip">*可以使用“复制并创建新版本“，并指定新的生效、失效时间，可以保证历史数据继续生效</p>
    <Tabs v-model="tabId" :animated="false" @on-click="tabChange" v-if="$units.pointAction('pro_7_1') && !isNew">
      <TabPane label="当前费率" name="1"></TabPane>
      <TabPane label="其他版本费率" name="2"></TabPane>
    </Tabs>
    <div v-if="data && tabId == '1'" class="btnBox clearfix">
      <div class="fir" v-if="!isEdit && !isNew">
        <div class="version-wrap left" v-if="version.versionNo && !isEdit && !isNew">
          有效期：{{ version.versionStartTime || '-' }} 至 {{ version.versionEndTime || '-' }}
        </div>
        <div class="right">
          <Button v-if="pageQuery.sourceType == 2 " type="primary" @click="showEdit()">编辑</Button>
          <Button v-if="pageQuery.sourceType == 2 && version.versionStartTime" type="primary" @click="copyCurrentCommision()"
            >复制并创建新版本</Button
          >
          <Poptip
            transfer
            width="200"
            style="margin-left: 10px"
            v-else-if="pageQuery.sourceType == 2"
            confirm
            title="当前版本没有有效期，是否先填写？"
            @on-ok="showEdit()"
            ok-text="确定"
            cancel-text="取消"
          >
            <Button type="primary">复制并创建新版本</Button>
          </Poptip>
        </div>
      </div>
      <div class="sed" v-else>
        <!-- <Button type="primary" ghost @click="cancel" style="margin-right: 10px">取消</Button>
        <Button type="primary" @click="$refs.editRateTable.save(true)">保存</Button> -->
      </div>
    </div>
    <!-- 当前费率 -->
    <rateTable
      v-show="tabId == '1' && !isEdit && !isNew"
      :sort="pageQuery.sourceType == 2 && $units.pointAction('pro_7_1')"
      :data="data"
      type="1"
      mode="base"
      ref="table"
      :setCommissionYear="$units.pointAction('pro_7_1')"
      sortType="product"
      @changeSort="saveSort"
      @save="openConfirmModal"
      @hideEdit="isEdit = false"
      @delYear="delYear"
      @addYear="addYear"
      @setFullYear="setFullYear"
      pageType="productLibrary"
    >
      <template v-if="pageQuery.sourceType == 2" #emptyText>
        <p>暂无数据</p>
      </template>
    </rateTable>
    <editRateTable
      ref="editRateTable"
      v-show="tabId == '1' && (isEdit || isNew)"
      :productInfo="pageQuery"
      :productAdditions="productAdditions"
      :programBases="programBases"
      :templateId="type ? type : tabList.length ? tabList[0].id : ''"
      @success="refreshData"
      @cancel="cancel"
    ></editRateTable>
    <!-- 其他版本费率 -->
    <version-list
      ref="versionList"
      v-show="tabId == '2'"
      @edit="edit"
      @callback="callback"
      :showPoptip="!version.versionStartTime"
      :query="query"
    ></version-list>
    <!-- 修改确认弹窗 -->
    <confirm-modal ref="confirmModal" @save="saveEdit"></confirm-modal>
    <!-- 删除确认弹窗 -->
    <confirm-modal ref="confirmModal2"></confirm-modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import upLoad from '@/components/commons/upload';
import { getCommissionTabs } from '@/api/httpList';
import editRateTable from './components/editRateTable';
import rateTable from '@/components/commons/feeTemplate/rateTable';
import versionList from './components/versionList';
import confirmModal from '@/components/commons/feeTemplate/confirmModal';
export default {
  mixins: [common],
  components: {
    upLoad,
    rateTable,
    versionList,
    confirmModal,
    editRateTable
  },
  props: {
    pageType: null // modal 弹窗模式
  },
  data() {
    return {
      tabId: '1',
      isEdit: false,
      isNew: false, //创建新版本
      pageLoading: false,
      type: null,
      isAdd: false,
      productBase: {
        companyName: '',
        supplierName: ''
      },
      query: {}, //历史费率参数
      pageQuery: {}, //页面参数
      tabList: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      gradeList: [],
      formDateAdd: [],
      modalType: '',
      isShow: false,
      data: {},
      activityInfo: {},
      productAdditions: [], //主险附加险
      programBases: [], //方案列表
      commissionList: [], //费用配置方案列表
      version: {} //版本信息
    };
  },
  watch: {},
  computed: {},
  activated() {
    if (this.tabId == '2') {
      this.tabChange();
    }
  },
  async created() {
    if (this.pageType == 'modal') {
      return;
    }
    if (this.$route.query.isEdit && this.$route.query.sourceType == 2) {
      this.pageQuery = this.$route.query;
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.query = {
        productCode: this.pageQuery.code,
        productName: this.pageQuery.name,
        nodeType: 1,
        id: userInfo.organId,
        pageType: 'productLibrary'
      };
      await this.queryGradeTreeByPlatformId();
      this.querySupplyInfos();
      await this.getCommissionTabList();
      await this.getCommission();
      await this.getCurrentVersion();
      this.showEdit();
    } else {
      this.init(this.$route.query);
    }
  },
  methods: {
    async refreshData() {
      this.isEdit = false;
      this.isNew = false;
      await this.queryGradeTreeByPlatformId();
      this.tabChange();
    },
    async init(data) {
      console.log(data);
      this.pageQuery = data;
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.query = {
        productCode: this.pageQuery.code,
        productName: this.pageQuery.name,
        nodeType: 1,
        id: userInfo.organId,
        pageType: 'productLibrary'
      };
      await this.queryGradeTreeByPlatformId();
      this.tabChange();
      this.querySupplyInfos();
    },
    querySupplyInfos() {
      this.$http({
        url: '/buz/upcommission/querySupplyInfos',
        type: 'GET',
        data: {
          productCode: this.pageQuery.code
        }
      }).then(res => {
        this.productBase = res.data;
      });
    },
    queryGradeTreeByPlatformId() {
      return this.$http({
        url: '/buz/programBase/queryGradeTreeById',
        type: 'GET',
        data: {
          id: this.pageQuery.id,
          programType: this.pageQuery.productCategory == 3 ? 1 : 2
        }
      }).then(res => {
        this.productAdditions = res.data.productAdditions; //主险&&附加险
        this.programBases = res.data.programBases; //所有方案
      });
    },
    // 切换tab
    async tabChange() {
      if (this.tabId == '1') {
        await this.getCommissionTabList();
        await this.getCommission();
        this.getCurrentVersion();
      } else if (this.tabId == '2') {
        this.$refs.versionList.init();
      }
    },
    getCurrentVersion() {
      return new Promise((resolve, reject) => {
        this.$http({
          url: `/buz/commission/version/read/currentVersion?productCode=${this.pageQuery.code}`,
          type: 'GET',
          data: {}
        }).then(res => {
          if (res.data) {
            console.log('当前版本号', res);
            this.version = res.data;
            this.pageQuery.versionNo = res.data.versionNo;
            this.pageQuery.versionStartTime = res.data.versionStartTime;
            this.pageQuery.versionEndTime = res.data.versionEndTime;
            this.pageQuery.versionType = res.data.versionType;
          } else {
            this.version = {};
            this.pageQuery.versionNo = undefined;
            this.pageQuery.versionStartTime = undefined;
            this.pageQuery.versionEndTime = undefined;
            this.pageQuery.versionType = undefined;
          }
          resolve();
        });
      });
    },
    //复制并创建版本
    copyCurrentCommision() {
      if (!this.$units.pointAction('pro_7_1')) {
        return this.$notice.error('无权操作，请联系您的上级');
      }
      this.$router.push({
        path: '/productResource/productManager/editProductManageCommissionDetail',
        query: {
          ...this.pageQuery,
          productId: this.pageQuery.id,
          productCode: this.pageQuery.code,
          isEdit: true,
          editType: '3',
          timeStr: new Date().getTime()
        }
      });
    },
    callback(row) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (row.versionType == -1 && row.editType != 3) {
        //过期版本不允许修改
        console.log('row---', row);
        this.$router.push({
          path: '/productResource/productManager/futureCommissionDetail',
          query: {
            versionNo: row.versionNo,
            productCode: this.pageQuery.code,
            productId: this.pageQuery.id,
            versionType: row.versionType,
            productCategory: this.pageQuery.productCategory,
            versionStartTime: row.versionStartTime,
            versionEndTime: row.versionEndTime,
            name: this.pageQuery.name
          }
        });
      } else {
        this.$router.push({
          path: '/productResource/productManager/editProductManageCommissionDetail',
          query: {
            productId: this.pageQuery.id,
            name: this.pageQuery.name,
            sourceType: this.pageQuery.sourceType,
            versionNo: row.versionNo,
            versionStartTime: row.versionStartTime,
            versionEndTime: row.versionEndTime,
            productCategory: this.pageQuery.productCategory,
            versionType: row.versionType,
            code: this.pageQuery.code,
            isEdit: row.editType != -1,
            editType: row.editType,
            id: row.id,
            timeStr: new Date().getTime()
          }
        });
      }
    },
    edit() {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.tabId = '1';
      this.isEdit = true;
      this.$refs.editRateTable.init(this.pageQuery);
    },
    // 显示编辑按钮
    showEdit() {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.isEdit = true;
      this.$refs.editRateTable.init(this.pageQuery);
    },
    // 打开确认弹窗
    openConfirmModal(data) {
      this.$refs.confirmModal.open(data);
    },
    /**
     * data 待保存数据
     * reload 是否需要刷新
     */
    saveEdit(data, reload = true) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const templateId = this.type ? this.type : this.tabList[0].id;
      const templateType = this.tabList.find(item => item.id === templateId).type;
      const productCode = this.pageQuery.code;
      if (this.pageLoading) {
        return;
      }
      this.pageLoading = true;
      return this.$http({
        url: '/buz/commission/sys/modify',
        type: 'POST',
        data: {
          templateId,
          templateType,
          productCode,
          commissionList: data.list
        }
      })
        .then(res => {
          if (reload) {
            this.$Message.success('保存成功');
            this.isEdit = false;
            this.isNew = false;
            this.$emit('reload');
            this.getCommission();
          }
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    saveSort(data) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      // const templateId = this.type ? this.type : this.tabList[0].id;
      // const templateType = this.tabList.find(item => item.id === templateId).type;
      const productCode = this.pageQuery.code;
      // commissionSortItems sortGradeCode sortProgramId isMain
      this.$http({
        url: '/buz/commission/sortNew',
        type: 'POST',
        data: {
          // templateId,
          // templateType,
          productCode,
          commissionSortItems: data.list
        }
      }).then(res => {
        this.getCommission();
        this.$emit('reload');
      });
    },
    async getCommissionTabList() {
      let res = await getCommissionTabs(this.pageQuery.code);
      this.tabList = res.data;
    },
    //查询档次
    async getCommission() {
      this.pageLoading = true;
      const type = this.type ? this.type : this.tabList[0].id;
      return this.$http({
        url: '/buz/commission/productRateDetailNew',
        type: 'GET',
        data: {
          productCode: this.pageQuery.code,
          templateId: type
        },
        apiPermissionCode: 'pro_2_5'
      })
        .then(res => {
          if (res.data) {
            this.data = res.data;
            this.data.templateId = type;
            if (res.data.activityInfoVO) {
              this.activityInfo = res.data.activityInfoVO;
            }
          } else {
            this.data = {
              commissionItems: [],
              programRules: this.pageQuery.productCategory == 3 ? [{ name: '交费期' }] : []
            };
          }
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    // 删除交费年限
    async delYear(params) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const data = this.$refs.table.getSaveData();
      if (data) {
        await this.saveEdit(data, false);
      }
      if (this.pageLoading) {
        return;
      }
      this.pageLoading = true;
      this.$http({
        url: '/buz/upcommission/delCommissionNum',
        type: 'POST',
        data: { ...params, versionNo: this.pageQuery.versionNo }
      })
        .then(async res => {
          await this.getCommission();
          window.setTimeout(() => {
            if (this.isEdit) {
              this.$refs.table.showEdit();
            }
          }, 100);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    // 新增交费年限
    async addYear(params) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const data = this.$refs.table.getSaveData();
      if (data) {
        await this.saveEdit(data, false);
      }
      if (this.pageLoading) {
        return;
      }
      this.pageLoading = true;
      this.$http({
        url: '/buz/upcommission/addCommissionNum',
        type: 'POST',
        data: { ...params, versionNo: this.pageQuery.versionNo }
      })
        .then(async res => {
          await this.getCommission();
          window.setTimeout(() => {
            if (this.isEdit) {
              this.$refs.table.showEdit();
            }
            $('.last-td')[0].scrollIntoView({ inline: 'end' });
          }, 100);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    cancel() {
      this.tabChange();
      this.isEdit = false;
      this.isNew = false;
    },
    // 设置至交费期满
    async setFullYear(params) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const data = this.$refs.table.getSaveData();
      if (data) {
        await this.saveEdit(data, false);
      }
      if (this.pageLoading) {
        return;
      }
      const untilLast = params.untilLast;
      delete params.untilLast;
      this.pageLoading = true;
      this.$http({
        url: untilLast ? '/buz/upcommission/setCommissionUntilLast' : '/buz/upcommission/cancelCommissionUntilLast',
        type: 'POST',
        data: { ...params, versionNo: this.pageQuery.versionNo }
      })
        .then(async res => {
          await this.getCommission();
          window.setTimeout(() => {
            if (this.isEdit) {
              this.$refs.table.showEdit();
            }
          }, 100);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.fu {
  background: #fff0ea;
  color: #ff7134;
  padding: 4px;
}

.product-manage-commission {
  .version-wrap {
    margin-bottom: 10px;
  }
  .btn-left {
    position: absolute;
    left: 40px;
  }
  position: relative;

  .info-text {
    color: #ff7134;
    white-space: pre-line;
  }
  /deep/.rate-table{
    .first-td{
      min-width: 300px!important;
    }
    .sec-td{
      left: 300px!important;
      min-width: 300px!important;
    }
  }
  .tableBox {
    table {
      width: 100%;
      border-collapse: collapse;

      input {
        // width: 100px;
      }

      thead {
        background: #f8f8f9;
      }

      th {
        border: 1px solid #eee;
        width: 100px;
        padding: 10px 10px;
      }

      td {
        text-align: center;
        border: 1px solid #eee;
        padding: 10px 10px;
      }
    }
  }

  .link {
    color: #236dff;
    cursor: pointer;
  }

  /deep/ .ivu-table-cell {
    padding-left: 0;
    padding-right: 0;
    height: 100%;
    display: flex;
    color: #3c464f;
    font-size: 14px;
    justify-content: center;
    align-items: center;
  }

  /deep/ .ivu-table-cell {
    line-height: 1;
  }

  .header {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    padding-right: 70px;
    position: relative;
    span {
      margin-right: 50px;
    }
    .ivu-btn {
      position: absolute;
      right: 0;
    }
  }

  .tag {
    margin-left: 10px;
    color: #515c6f;
    font-size: 12px;
    background: #e3e5e8;
    border-radius: 4px;
    width: 50px;
    display: inline-block;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border: 1px solid #ced1d5;
    margin-top: 5px;

    &.active {
      background: #fff0ea;
      color: #ff7134;
      border: 1px solid #ff7134;
    }
  }

  background: #fff;

  .upLoadBox {
    margin-left: 30px;
    margin-bottom: 30px;
  }

  /deep/ .btn {
    color: #236dff;
    float: left;
    margin-right: 20px;

    &:hover {
      cursor: pointer;
    }
  }
  .tip{
    color: #ff7134;
    margin-bottom: 10px;
  }
  .btnBox {
    width: 100%;
    text-align: right;
    margin-bottom: 10px;
    margin-top: 10px;
    // position: absolute;
    // right: 20px;
    z-index: 1;

    .fir {
      .left {
        float: left;
      }

      .right {
        float: right;
      }
    }
  }

  .pageBox {
    margin-top: 20px;
  }

  .activity-info {
    span {
      margin-right: 20px;
    }
  }
  .station-box {
    height: 40px;
  }
}
</style>